import React from 'react'
import type { WorkflowNodeData } from '@/types/workflow'

interface GoalConfigProps {
  data: WorkflowNodeData
  updateField: (field: string, value: any) => void
}

import { inputClass, inputStyle, sectionClass, infoBannerClass } from './_kit'
import { Select } from '@/components/ui/Select'
import { Field } from '@/components/ui/Field'

const GOAL_TYPE_OPTIONS = [
  { value: 'replied', label: 'Contact Replied' },
  { value: 'clicked_link', label: 'Clicked a Link' },
  { value: 'booked_meeting', label: 'Booked a Meeting' },
  { value: 'custom', label: 'Custom Goal' },
]

const GoalConfig: React.FC<GoalConfigProps> = ({ data, updateField }) => {
  const config = data.goal_config || { goal_type: 'replied' }

  const updateGoal = (key: string, value: any) => {
    updateField('goal_config', { ...config, [key]: value })
  }

  return (
    <div className={sectionClass}>
      <Field label="Label">
        {(f) => (
          <input
            {...f}
            type="text"
            value={data.label || ''}
            onChange={(e) => updateField('label', e.target.value)}
            placeholder="e.g., Meeting Booked"
            className={inputClass} style={inputStyle}
          />
        )}
      </Field>

      <Field label="Goal Type">
        {(f) => (
          <Select
            {...f}
            value={config.goal_type}
            onChange={(value) => updateGoal('goal_type', value)}
            options={GOAL_TYPE_OPTIONS}
            className="w-full"
          />
        )}
      </Field>

      {config.goal_type === 'custom' && (
        <Field label="Custom Goal Description">
          {(f) => (
            <input
              {...f}
              type="text"
              value={config.goal_value || ''}
              onChange={(e) => updateGoal('goal_value', e.target.value)}
              placeholder="Describe the goal..."
              className={inputClass} style={inputStyle}
            />
          )}
        </Field>
      )}

      <div className={infoBannerClass}>
        <p className="text-xs">
          When a contact reaches this node and meets the goal criteria, they are marked as <strong>completed</strong> in the workflow. The contact can still continue through subsequent nodes.
        </p>
      </div>
    </div>
  )
}

export default GoalConfig
